// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  BugReportStatus,
  ReportKind,
  Priority,
} from "./types";


export default __t.row({
  id: __t.u64().primaryKey(),
  reporterIdentity: __t.identity().name("reporter_identity"),
  orgId: __t.string().name("org_id"),
  get status() {
    return BugReportStatus;
  },
  get kind() {
    return ReportKind;
  },
  summary: __t.string(),
  description: __t.string(),
  systemInfo: __t.string().name("system_info"),
  includeScreenshot: __t.bool().name("include_screenshot"),
  includeLog: __t.bool().name("include_log"),
  reporterDisplayName: __t.option(__t.string()).name("reporter_display_name"),
  reporterEmail: __t.option(__t.string()).name("reporter_email"),
  reporterOrgName: __t.option(__t.string()).name("reporter_org_name"),
  reporterProjectName: __t.option(__t.string()).name("reporter_project_name"),
  reporterProjectId: __t.option(__t.string()).name("reporter_project_id"),
  get priority() {
    return Priority;
  },
  category: __t.option(__t.string()),
  triagedBy: __t.option(__t.identity()).name("triaged_by"),
  triagedAt: __t.option(__t.timestamp()).name("triaged_at"),
  closedReason: __t.option(__t.string()).name("closed_reason"),
  githubRepoOwner: __t.option(__t.string()).name("github_repo_owner"),
  githubRepoName: __t.option(__t.string()).name("github_repo_name"),
  githubIssueNumber: __t.option(__t.u64()).name("github_issue_number"),
  githubIssueUrl: __t.option(__t.string()).name("github_issue_url"),
  lastSyncedAt: __t.option(__t.timestamp()).name("last_synced_at"),
  lastGithubError: __t.option(__t.string()).name("last_github_error"),
  syncAttempts: __t.u32().name("sync_attempts"),
  createdAt: __t.timestamp().name("created_at"),
  updatedAt: __t.timestamp().name("updated_at"),
  stamp: __t.option(__t.string()),
});
